// src/utils/globalModal.js
import { createApp, h } from 'vue';

let modalInstance = null;
let modalApp = null;

/**
 * 显示全局弹窗
 */
export const showGlobalModal = () => {
  // 如果已经存在实例，直接打开
  if (modalInstance) {
    modalInstance.open();
    return;
  }

  // 创建新的弹窗实例
  const container = document.createElement('div');
  container.id = 'global-modal-container';
  document.body.appendChild(container);

  // 动态导入组件
  import('@/components/GlobalModal.vue').then((module) => {
    const GlobalModal = module.default;
    
    // 创建独立的Vue应用
    modalApp = createApp({
      render() {
        return h(GlobalModal, {
          ref: 'modal',
          onClosed: () => {
            // 关闭后销毁实例
            if (modalApp) {
              modalApp.unmount();
              modalApp = null;
              modalInstance = null;
              if (container.parentNode) {
                container.parentNode.removeChild(container);
              }
            }
          }
        });
      }
    });

    // 挂载应用
    modalApp.mount(container);
    
    // 获取组件实例并打开
    modalInstance = modalApp._container._vnode.component.refs.modal;
    modalInstance.open();
  });
};

/**
 * 隐藏全局弹窗
 */
export const hideGlobalModal = () => {
  if (modalInstance) {
    modalInstance.close();
  }
};